var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReply = function SvgReply(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.825 12 2.9 2.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-4.6-4.6a.96.96 0 0 1-.3-.7q0-.4.3-.7l4.6-4.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.713 0 .412-.3.712L6.825 10H16q2.075 0 3.538 1.463T21 15v3q0 .424-.288.712A.97.97 0 0 1 20 19a.97.97 0 0 1-.712-.288A.97.97 0 0 1 19 18v-3q0-1.25-.875-2.125A2.9 2.9 0 0 0 16 12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReply);
export { ForwardRef as ReactComponent };